var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('title-minor',[_vm._v(" <"+_vm._s(_vm.name)),_c('tpl',{attrs:{"content":_vm.inlineAttrs}}),_vm._v("> "+_vm._s(_vm.slotDescr)+" </"+_vm._s(_vm.name)+"> ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }